/**
 * Simple Toast Notification Component
 */

import React, { useEffect } from 'react';
import './SimpleToast.css';

const SimpleToast = ({ message, type = 'info', onClose, duration = 4000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return (
    <div className={`simple-toast simple-toast-${type}`} role="alert" aria-live="assertive">
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={onClose} aria-label="Close notification">×</button>
    </div>
  );
};

export default SimpleToast;
